var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 106,
    viewBox: "0 0 111 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 48.2019V32.4519L73.75 53.4519L47.5 74.4519V58.7019H0.25V48.2019H47.5ZM7.9045 69.2019H19.0555C22.7202 78.2271 29.407 85.6985 37.9719 90.3381C46.5368 94.9777 56.4476 96.4973 66.0091 94.6368C75.5706 92.7764 84.1886 87.6515 90.389 80.1389C96.5893 72.6263 99.9867 63.1927 100 53.4519C100.005 43.7009 96.6178 34.2518 90.4182 26.7253C84.2186 19.1989 75.5934 14.0641 66.0218 12.2017C56.4503 10.3393 46.529 11.8653 37.9596 16.518C29.3902 21.1708 22.7067 28.6603 19.0555 37.7019H7.9045C14.593 16.4027 34.4905 0.951904 58 0.951904C86.9958 0.951904 110.5 24.4562 110.5 53.4519C110.5 82.4477 86.9958 105.952 58 105.952C34.4905 105.952 14.593 90.5012 7.9045 69.2019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign-in.dcb67188c7a0c3b55302c474e135098f.svg";
export { ForwardRef as ReactComponent };